import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderItemsService } from './logic/order-item.service';
import { OrderItemsLogicService } from './logic/order-item/order-item-logic.service';
import { OrderItemsDaoService } from './dao/order-item-dao.service';
import { OrderItemsDbDaoService } from './dao/order-item-dao/order-item-db-dao.service';
import { LocalOrderItemDbTableDefinition } from './dao/order-item-dao/local-order-item-db-table-definition';
import { OrderItemDbTableDefinition } from './dao/order-item-dao/order-item-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: OrderItemsService, useClass: OrderItemsLogicService },
    { provide: OrderItemsDaoService, useClass: OrderItemsDbDaoService },
    { provide: OrderItemDbTableDefinition },
    { provide: LocalOrderItemDbTableDefinition },
  ]
})
export class OrderItemsModule {}
